import React, { FC, memo, useCallback, useMemo } from 'react';
import { FlexColumn } from '../basic-flex/flex-column';
import { SkioldTextField } from '../skiold-components/skiold-text-field/skiold-text-field';
import { localized } from 'shared/state/i18n/i18n';
import { FormTitle } from './form-title';
import { FormRow } from '../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper-types';
import { SkioldFormsWrapper } from '../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { useSiteContext } from './create-site-context-provider';
import { SkioldFormInput } from '../skiold-components/skiold-input/skiold-form-input';
import { useSelector } from 'react-redux';
import { WebAppState } from 'web/state/store.web';
import { Option } from 'react-dropdown';
import { SkioldDropdown } from '../skiold-components/skiold-dropdown/skiold-dropdown';
import { SkioldFormDropdown } from '../skiold-components/skiold-dropdown/skiold-form-dropdown';
import './site-information.scss';
interface Props {}

export const SiteInformation: FC<Props> = memo(() => {
	const { fields, setField } = useSiteContext();

	const onChrNrChanged = useCallback((text: string) => setField('chrNr', text), [setField]);
	const onAddressChanged = useCallback((text: string) => setField('addresse', text), [setField]);
	const onPostNrChanged = useCallback((text: string) => setField('postNr', text), [setField]);
	const onCityChanged = useCallback((text: string) => setField('city', text), [setField]);
	const onNameChanged = useCallback((text: string) => setField('name', text), [setField]);
	const onCountryChanged = useCallback((option: Option) => setField('country', option.value), [setField]);

	const countries = useSelector((state: WebAppState) => state.countries.countries);

	const countryOptions: Option[] = useMemo(() => {
		return countries.map(country => {
			const option: Option = {
				label: country.name ?? '',
				value: country.code ?? '',
			};
			return option;
		});
	}, [countries]);

	const formRows: Array<FormRow> = useMemo(() => {
		return new Array<FormRow>(
			{
				name: localized('siteName'),
				component: <SkioldFormInput text={fields.name} onChangeText={onNameChanged} />,
			},

			{
				name: localized('siteAddress'),
				component: <SkioldFormInput text={fields.addresse} onChangeText={onAddressChanged} />,
			},
			{
				name: localized('siteZipCode'),
				component: <SkioldFormInput text={fields.postNr} onChangeText={onPostNrChanged} />,
			},
			{
				name: localized('siteCity'),
				component: <SkioldFormInput text={fields.city} onChangeText={onCityChanged} />,
			},
			{
				name: localized('country'),
				component: (
					<SkioldFormDropdown
						onValueChanged={onCountryChanged}
						items={countryOptions}
						className="skiold-dropdown"
						selectedValue={countryOptions.find(co => co.value === fields.country)}
					/>
				),
			},
			{
				name: localized('chrNum'),
				component: <SkioldFormInput useAsInterger={true} text={fields.chrNr} onChangeText={onChrNrChanged} />,
			},
		);
	}, [
		fields.name,
		fields.addresse,
		fields.postNr,
		fields.city,
		fields.chrNr,
		fields.country,
		onNameChanged,
		onAddressChanged,
		onPostNrChanged,
		onCityChanged,
		onCountryChanged,
		countryOptions,
		onChrNrChanged,
	]);

	return (
		<FlexColumn className="site-information-form">
			<FormTitle title={localized('Farm')} />
			<SkioldFormsWrapper formRows={formRows} containerClassName="site-information-form-wrapper" />
		</FlexColumn>
	);
});
